<div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <h2 class="text-center mb-4 bigTitleCol">{{ 'CHANGE_PASSWORD_PAGE.TITLE' | translate }}</h2>
        <form (ngSubmit)="onSubmitPasswordChange()" #passwordForm="ngForm">
  
          <div class="mb-3">
            <label for="currentPassword" class="form-label">
              {{ 'CHANGE_PASSWORD_PAGE.CURRENT_PASSWORD_LABEL' | translate }}
            </label>
            <input [type]="showCurrentPassword ? 'text' : 'password'"
                   class="form-control form-control-sm"
                   id="currentPassword"
                   name="currentPassword"
                   [(ngModel)]="passwordData.current_password"
                   required
                   #currentPasswordInput="ngModel"
                   [disabled]="isLoading"
                   placeholder="{{ 'REGISTER.PASSWORD_PLACEHOLDER' | translate }}">
            <div *ngIf="currentPasswordInput.invalid && (currentPasswordInput.dirty || currentPasswordInput.touched)"
                 class="text-danger mt-1 small">
              <div *ngIf="currentPasswordInput.errors?.['required']">
                {{ 'VALIDATION.REQUIRED_FIELD' | translate }}
              </div>
            </div>
          </div>
          <div class="mb-3 form-check">
            <input type="checkbox" class="form-check-input" id="showCurrentPasswordCheck"
                   [(ngModel)]="showCurrentPassword" name="showCurrentPassToggle" [disabled]="isLoading">
                   <label class="form-check-label" for="showCurrentPasswordCheck">
              {{ 'LOGIN.SHOW_PASSWORD' | translate }}
            </label>
          </div>
  
          <div class="mb-3">
            <label for="newPassword" class="form-label">
              {{ 'CHANGE_PASSWORD_PAGE.NEW_PASSWORD_LABEL' | translate }}
            </label>
            <input [type]="showNewPassword ? 'text' : 'password'"
                   class="form-control form-control-sm"
                   id="newPassword"
                   name="newPassword"
                   [(ngModel)]="passwordData.new_password"
                   required
                   minlength="6" #newPasswordInput="ngModel"
                   [disabled]="isLoading"
                   placeholder="{{ 'REGISTER.PASSWORD_PLACEHOLDER' | translate }}">
            <div *ngIf="newPasswordInput.invalid && (newPasswordInput.dirty || newPasswordInput.touched)"
                 class="text-danger mt-1 small">
              <div *ngIf="newPasswordInput.errors?.['required']">
                {{ 'VALIDATION.REQUIRED_FIELD' | translate }}
              </div>
              <div *ngIf="newPasswordInput.errors?.['minlength']">
                {{ 'VALIDATION.PASSWORD_MIN_LENGTH' | translate : {min: 6} }}
              </div>
            </div>
          </div>
          <div class="mb-3 form-check">
            <input type="checkbox" class="form-check-input" id="showNewPasswordCheck"
                   [(ngModel)]="showNewPassword" name="showNewPassToggle" [disabled]="isLoading">
                   <label class="form-check-label" for="showNewPasswordCheck">
              {{ 'LOGIN.SHOW_PASSWORD' | translate }}
            </label>
          </div>
  
          <div class="mb-3">
            <label for="confirmNewPassword" class="form-label">
              {{ 'CHANGE_PASSWORD_PAGE.CONFIRM_PASSWORD_LABEL' | translate }}
            </label>
            <input [type]="showConfirmPassword ? 'text' : 'password'"
                   class="form-control form-control-sm"
                   id="confirmNewPassword"
                   name="confirmNewPassword"
                   [(ngModel)]="passwordData.new_password_confirmation"
                   required
                   #confirmNewPasswordInput="ngModel"
                   (ngModelChange)="checkPasswordsMatch()"
                   [disabled]="isLoading"
                   placeholder="{{ 'REGISTER.CONFIRM_PASSWORD_PLACEHOLDER' | translate }}">
            <div *ngIf="confirmNewPasswordInput.invalid && (confirmNewPasswordInput.dirty || confirmNewPasswordInput.touched) && confirmNewPasswordInput.errors?.['required']"
                 class="text-danger mt-1 small">
              {{ 'VALIDATION.REQUIRED_FIELD' | translate }}
            </div>
            <div *ngIf="passwordForm.controls['newPassword']?.value !== passwordForm.controls['confirmNewPassword']?.value && confirmNewPasswordInput.dirty && !confirmNewPasswordInput.errors?.['required']"
                 class="text-danger mt-1 small">
              {{ 'VALIDATION.PASSWORDS_DO_NOT_MATCH' | translate }}
            </div>
          </div>
          <div class="mb-3 form-check">
            <input type="checkbox" class="form-check-input" id="showConfirmPasswordCheck"
                   [(ngModel)]="showConfirmPassword" name="showConfirmPassToggle" [disabled]="isLoading">
                   <label class="form-check-label" for="showConfirmPasswordCheck">
              {{ 'LOGIN.SHOW_PASSWORD' | translate }}
            </label>
          </div>
  
          <div *ngIf="apiSuccessMessage && !isLoading" class="alert alert-success small p-2 mt-3">
            {{ apiSuccessMessage }}
          </div>
  
          <div *ngIf="apiErrorMessage && !isLoading" class="alert alert-danger small p-2 mt-3">
            {{ apiErrorMessage }}
          </div>
  
          <div class="d-grid gap-2 mt-4">
            <button type="submit" class="btn button-primary-purple btn-lg"
                    [disabled]="passwordForm.invalid || (passwordData.new_password !== passwordData.new_password_confirmation && passwordForm.controls['confirmNewPassword']?.dirty) || isLoading">
              <span *ngIf="isLoading; else submitButtonText">
                {{ 'CHANGE_PASSWORD_PAGE.PROCESSING' | translate }} <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </span>
              <ng-template #submitButtonText>{{ 'CHANGE_PASSWORD_PAGE.SUBMIT_BUTTON' | translate }}</ng-template>
            </button>
            <button type="button" class="btn btn-outline-secondary btn-lg mt-2" (click)="goBack()" [disabled]="isLoading">
              {{ 'CHANGE_PASSWORD_PAGE.CANCEL_BUTTON' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>